import {
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  Input,
  OnChanges,
  OnInit,
  SimpleChange,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ValidationService } from '../services';
import { Observable, observableOf, rx, Subject } from '@shared/rx';
import { onControlIsInvalidChanged } from '@shared/rx-operators';
import { XVII18nService } from '@app/i18n/services';

@Component({
  selector: 'xvi-error-block',
  templateUrl: './error-block.component.html',
  styleUrls: ['./error-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVIErrorBlockComponent implements OnChanges, OnInit, DoCheck {
  @Input() public control?: FormControl;
  @Input() public showPristineErrors: boolean = false;

  public errorMessage$: Observable<string>;
  public isInvalid$: Observable<boolean>;
  public isDirtyOrTouched$: Observable<boolean>;

  private _isDirtyOrTouched$: Subject<boolean> = new Subject();

  public constructor(public i18nService: XVII18nService) {}

  public ngOnChanges(
    changes: Record<keyof XVIErrorBlockComponent, SimpleChange | undefined>,
  ): void {
    if (changes.control) this.initControlStreams();
  }

  public ngOnInit(): void {
    this.isDirtyOrTouched$ = this._isDirtyOrTouched$.pipe(
      rx.distinctUntilChanged(),
    );
  }

  public ngDoCheck(): void {
    // We have to use ngDoCheck because Angular's Controls don't have a stream to subscribe on .dirty / .touch change
    this._isDirtyOrTouched$.next(
      (this.control?.dirty || this.control?.touched) ?? false,
    );
  }

  private initControlStreams(): void {
    if (!this.control) {
      this.errorMessage$ = observableOf('');
      this.isInvalid$ = observableOf(false);

      return;
    }

    this.errorMessage$ = this.control.statusChanges.pipe(
      // eslint-disable-next-line import/no-deprecated
      rx.startWith(null),
      rx.map(() =>
        ValidationService.getTextFromControlErrors(this.control.errors, {
          i18nService: this.i18nService,
        }),
      ),
    );
    this.isInvalid$ = onControlIsInvalidChanged(this.control);
  }
}
